import {obtenerIDLocal} from "./obtenerIDLocal";
import {doc, setDoc, updateDoc} from "firebase/firestore";
import {fire} from "../../fire";

export const registrarFecha = async ({metrica,coleccion='metricas'}) => {

    let uid = obtenerIDLocal()
    let referencia = doc(fire, coleccion, uid)

    try {
        await updateDoc(referencia, {[metrica]: new Date().getTime()});
    } catch (err) {
        await setDoc(referencia, {[metrica]: new Date().getTime(), id: uid});
    }

}